module.exports = __webpack_public_path__ + "012878a30052e24163d5fb1a8d51bb6b.png";